export interface MailSettings {
    displayName: string;
    smtp: boolean;
    auth: boolean;
    email: string;
    host: string;
    port: number | null;
    login: string;
    password: string;
    protocol: string;
}

export const initialMailSettings: Readonly<MailSettings> = {
    displayName: '',
    smtp: false,
    auth: true,
    email: '',
    host: '',
    port: null,
    login: '',
    password: '',
    protocol: '',
};
